<template >
  <Modal v-model="printModal" title="打印标签" @on-visible-change="visible" :styles="{top: '80px',width:'870px'}" class="headerBar" :closable="false" :mask-closable="false">
    <div>
      <Card dis-hover v-if="showPrintItem.indexOf('widthAndHeight') != -1">
        <div>
          <span>介质材料</span>
          <span style="margin-left:20px;margin-right:10px;">宽</span>
          <InputNumber v-model.trim="printParams.width" :max="100" @on-change="changeWidth" style="width:100px;margin-right:10px;" size="small"></InputNumber>
          mm <span style="margin-left:20px;margin-right:10px;">高</span>
          <InputNumber v-model.trim="printParams.height" :max="100" @on-change="changeHeight" style="width:100px;margin-right:10px;" size="small"></InputNumber>
          mm <span style="margin-left:20px;color:red;font-size:12px;">最大支持100mm X 100mm</span>
        </div>
        <div class="mt15" v-if="showPrintItem.indexOf('fontSize') != -1">
          <span>标签大小</span>
          <span style="margin-left:20px;margin-right:10px;">条码字体</span>
          <InputNumber v-model.trim="printParams.barcodeSize" style="width:100px;margin-right:10px;" size="small" @on-change="changeBarSize"></InputNumber>
          pt <span style="margin-left:20px;color:red;font-size:12px;">每pt约占0.35mm宽，请确保最长的SKU字符数*左侧pt值*0.35小于介质尺寸</span>
        </div>
        <div class="mt15" v-if="showPrintItem.indexOf('productNo') != -1">
          <span>商品编号</span>
          <dyt-select style="width:150px;margin-left:35px;" v-model="printParams.productNo" @on-change="changeProNo">
            <Option :value="0">不打印SKU</Option>
            <Option :value="1">打印SKU</Option>
          </dyt-select>
        </div>
        <div class="mt15" v-if="showPrintItem.indexOf('productZhName') != -1">
          <span>商品中文名称</span>
          <dyt-select style="width:150px;margin-left:35px;" v-model="printParams.productZhName" @on-change="changeProName">
            <Option :value="0">不打印商品中文名称</Option>
            <Option :value="1">打印商品中文名称</Option>
          </dyt-select>
        </div>
        <div class="mt15" v-if="showPrintItem.indexOf('customContent') != -1">
          <span>自定义内容</span>
          <dyt-select style="width:150px;margin-left:20px;" v-model="printParams.custom" @on-change="changeCustom">
            <Option :value="0">不打印自定义内容</Option>
            <Option :value="1">打印自定义内容</Option>
          </dyt-select>
          <Input v-if="printParams.custom" v-model.trim="tagContent" @on-enter="addTag" style="width:150px;margin-left:20px;" />
          <Button v-if="printParams.custom" style="margin-left:10px;" type="primary" size="small" @click="addTag">增加</Button>
          <Tag class="tag" v-if="printParams.custom" v-for="(item, index) in tagList" :key="index" closable @on-close="delConfirm(index)" style="margin:5px;">
            {{ item }}
          </Tag>
          <div style="text-align: right;">
            <span style="font-size:12px;color:green;margin-top:20px;" >注:打印内容可拖动改变位置</span>
          </div>
        </div>
      </Card>
    </div>
    <div class="mt15">
      <Row >
        <Col span="12">
          <div >
            <Row style="margin-bottom:10px;">
              <Col span="10" >货品</COl>
              <Col span="14" >
                统一设置打印数量
                <InputNumber v-model.trim="printNum" style="width:calc(100% - 125px);" size="small" @on-blur="changePrintNum"></InputNumber>
              </COl>
            </Row>
            <Table border :columns="printColumns" :data="pageData"></Table>
          </div>
        </COl>
        <Col span="12">
          <Card dis-hover style="margin-left:5px;height:420px;background:#e8e8e8;overflow:auto;display:flex;justify-content:center;align-items:center;">
            <div :style="pageClass" ref="container" class="container" v-if="pageData.length != 0">
              <div
                ref="barCode"
                class="draggable"
                data-name="barCode"
                :style="barCodeClass"
                v-html="pageData[0][printViewParams[0]]"
              ></div>
              <div
                ref="title"
                class="draggable"
                data-name="title"
                v-show="printParams.productZhName"
              >{{ pageData[0][printViewParams[1]] }}</div>
              <div
                ref="sku"
                class="draggable"
                data-name="sku"
                v-show="printParams.productNo"
              >{{ pageData[0][printViewParams[2]] }}</div>
              <template v-if="tagList.length">
                <div
                  v-for="(item, index) in tagList"
                  style="position: absolute; left: 0; top: 0;"
                  :ref="`draggableTag${index}`"
                  class="draggable"
                  :key="`${index}`"
                  :data-name="`draggableTag${index}`"
                >{{ item }}</div>
              </template>
            </div>
          </Card>
        </COl>
      </Row>
    </div>
    <div slot="footer">
      <Button type="primary" @click="printBarcode" >打印 </Button>
      <Button @click="cancelPrintBarcode" >取消</Button>
    </div >
    <div ref="tagTemp" style="display: none;"></div>
  </Modal>
</template>

<script>
import Draggabilly from 'draggabilly';
import common from '@/components/mixin/common_mixin';

export default {
  name: 'print',
  mixins: [common],
  components: { Draggabilly },
  props: {
    printData: {
      type: Array,
      default: () => {
        return [
          {
            sku: '123',
            title: '55555',
            num: 2,
            skuBarCode: '48787'
          }
        ];
      }
    },
    printColumns: {
      type: Array,
      default: () => {
        return [
          {
            title: 'SKU',
            key: 'sku',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              return h('div', [
                h('div', params.row.sku), h('div', params.row.fnsku)
              ]);
            }
          }, {
            title: '标题',
            key: 'title',
            align: 'center',
            minWidth: 120
          }, {
            title: '打印数量',
            key: 'number',
            align: 'center',
            minWidth: 100,
            render: (h, { row, index }) => {
              return h('Input', {
                props: {
                  value: this.pageData[index].number,
                  size: 'small'
                },
                on: {
                  'input': (val) => {
                    this.pageData[index].number = val;
                  }
                }
              });
            }
          }
        ];
      },
      required: true
    },
    showPrintItem: {
      type: Array,
      default: () => {
        return ['widthAndHeight', 'fontSize', 'productNo', 'productZhName', 'customContent'];
      }
    },
    printViewParams: {
      type: Array,
      default: () => {
        return ['skuBarCode', 'cnName', 'sku'];
      }
    }
  },
  data () {
    // 数量 num
    return {
      printModal: false,
      FixedValue: 2.83,
      offsetXY: [],
      pageData: [],
      printNum: 1,
      printParams: {
        width: 60,
        height: 40,
        barcodeSize: 12,
        productNo: 0,
        productZhName: 1,
        custom: 0
      },
      oldParams: {},
      pageClass: {
        position: 'relative',
        width: '169.8pt',
        height: '113.2pt',
        background: '#fff',
        textAlign: 'center'
      },
      pageClassCopy: null,
      barCodeClass: {
        fontFamily: 'IDAutomationC128S',
        lineHeight: '22pt',
        fontSize: '12pt'
      },
      barCodeClassCopy: null,
      tagContent: null,
      tagList: []
    };
  },
  watch: {
    pagePrintData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.pageData = this.deepCopy(val);
      }
    }
  },
  methods: {
    getLocal () {
      let data = localStorage.getItem('printSetting');
      if (data) {
        let localDate = JSON.parse(data);
        Object.keys(localDate).forEach(key => {
          if (!this.$common.isEmpty(localDate[key])) {
            this.printParams[key] = localDate[key];
          } else {
            this.printParams[key] = this.oldParams[key];
          }
        });
        if (!this.$common.isEmpty(this.printParams.width)) {
          this.pageClass.width = (this.printParams.width * this.FixedValue) + 'pt';
        } else {
          this.pageClass.width = (this.oldParams.width * this.FixedValue) + 'pt';
        }
        if (!this.$common.isEmpty(this.printParams.height)) {
          this.pageClass.height = (this.printParams.height * this.FixedValue) + 'pt';
        } else {
          this.pageClass.height = (this.oldParams.height * this.FixedValue) + 'pt';
        }
      } else {
        localStorage.setItem('printSetting', JSON.stringify(this.printParams));
      }
      this.getPosition();
    },
    setLocal (key, value) {
      let data = localStorage.getItem('printSetting') ? JSON.parse(localStorage.getItem('printSetting')) : {};
      data[key] = value;
      localStorage.setItem('printSetting', JSON.stringify(data));
    },
    getPosition () {
      // 获取本地位置
      let data = localStorage.getItem('positionPrint');
      if (data) {
        let localDate = JSON.parse(data);
        Object.values(localDate || {}).forEach((i) => {
          if (!this.$common.isEmpty(i) && this.$refs[i.key]) {
            this.$refs[i.key].style.top = i.top;
          }
        });
      }
    },
    jsonp (url) {
      if (!url) {
        return;
      }
      return new Promise((resolve, reject) => {
        window.jsonCallBack = (result) => {
          resolve(result);
        };
        var JSONP = document.createElement('script');
        JSONP.type = 'text/javascript';
        JSONP.src = url;
        JSONP.onerror = function () {
          resolve('error');
        };
        document.getElementsByTagName('head')[0].appendChild(JSONP);
        setTimeout(() => {
          document.getElementsByTagName('head')[0].removeChild(JSONP);
        }, 500);
      });
    },
    visible (open) {
      if (open) {
        this.jsonp('http://127.0.0.1:10099/check?callback=checkHandler&_=' + new Date().getTime()).then((res) => {
          if (res === 'error') {
            this.getPrintExeUrl().then(data => {
              if (data) {
                this.$Modal.info({
                  width: 400,
                  content: `请下载打印控件<a href=${data}>点击下载</a>`
                });
              } else {
                return new Error('未获取到打印控件');
              }
            });
          }
        });
        this.$nextTick(() => {
          this.showPrint();
          this.getLocal();
        });
      }
    },
    changeWidth (val) {
      let v = this;
      v.pageClass.width = (val * v.FixedValue) + 'pt';
      v.setLocal('width', val);
    },
    changeHeight (val) {
      let v = this;
      v.pageClass.height = (val * v.FixedValue) + 'pt';
      v.setLocal('height', val);
    },
    changeBarSize (val) {
      let v = this;
      v.barCodeClass.fontSize = val + 'pt';
      v.setLocal('barcodeSize', val);
    },
    changeProNo (val) {
      if (val) {
        this.showPrint();
      }
      this.setLocal('productNo', val);
    },
    changeProName (val) {
      if (val) {
        this.showPrint();
      }
      this.setLocal('productZhName', val);
    },
    changeCustom (val) {
      this.setLocal('custom', val);
    },
    addTag () {
      return new Promise((resolve) => {
        if (this.tagContent) {
          this.tagList.push(this.tagContent);
          this.tagContent = null;
          this.$nextTick(() => {
            if (this.$refs[`draggableTag${this.tagList.length - 1}`] && this.$refs[`draggableTag${this.tagList.length - 1}`][0]) {
              const draggie = new Draggabilly(this.$refs[`draggableTag${this.tagList.length - 1}`][0], {
                containment: true,
                axis: 'xy'
              });
              resolve({ drag: draggie });
              return;
            }
            resolve({ drag: null });
          });
          return;
        }
        resolve({ drag: null });
      })
    },
    showPrint () {
      let dragArr = [];
      const glKey = ['barCode', 'title', 'sku'];
      glKey.forEach((key) => {
        if (this.$refs[key]) {
          dragArr.push({
            el: this.$refs[key],
            keyName: this.$refs[key].getAttribute('data-name'),
            drag: new Draggabilly(this.$refs[key], {
            // 选项...
              containment: true,
              axis: 'y'
            })
          });
        }
      });
      let data = {};
      dragArr.forEach((item) => {
        item.drag.on('dragEnd', (e) => {
          // 设置位置
          data = localStorage.getItem('positionPrint') ? JSON.parse(localStorage.getItem('positionPrint')) : {};
          data[item.keyName] = {
            left: e.target.style.left,
            top: e.target.style.top,
            key: item.keyName
          };
          if (glKey.includes(item.keyName)) {
            localStorage.setItem('positionPrint', JSON.stringify(data));
          }
        });
      });
    },
    changePrintNum () {
      const newData = this.deepCopy(this.pageData);
      this.$nextTick(() => {
        newData.forEach((n, i) => {
          n.number = this.printNum;
          n.num = this.printNum;
        });
        this.pageData = newData;
        // 有可能列设置在父级，所有需要更新父级数据
        this.$emit('dataChange', newData);
      });
    },
    printBarcode () { // 打印条码
      let v = this;
      let instance = this.axios.create({
        timeout: 3000,
        transformRequest: [
          function (data) {
            let ret = '';
            for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            return ret;
          }
        ],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      instance.post('http://localhost:10099/print', {
        content: this.htm5Doc(),
        postId: '1'
      }).then(response => {
        if (response.status === 200) {
          this.$Message.success('操作成功');
          this.cancelPrintBarcode();
        }
      }).catch(() => {
        v.getPrintExeUrl().then(data => {
          if (data) {
            v.$Modal.info({
              width: 400,
              content: `请下载打印控件<a href=${data}>点击下载</a>`
            });
          } else {
            return new Error('未获取到打印控件');
          }
        });
      });
    },
    htm5Doc () {
      return (`<!DOCTYPE html>
        <html lang="en">
          <head>
            <meta charset="UTF-8">
            <title>Title</title>
            <style type="text/css">
              @media print {.btn{display: none;}}
              .bug-free{background:url('${window.location.origin}/setting-service/static/printFont/IDAutomationC128S.eot?#iefix')}
              #barcode{background:url('${window.location.origin}/setting-service/static/printFont/IDAutomationC128S.eot?#iefix')}
              @font-face {
                font-family: 'IDAutomationC128S';
                src: url('${window.location.origin}/setting-service/static/printFont/IDAutomationC128S.eot'); /* IE9 Compat Modes */
                src: url('${window.location.origin}/setting-service/static/printFont/IDAutomationC128S.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
                url('${window.location.origin}/setting-service/static/printFont/IDAutomationC128S.woff') format('woff'), /* Modern Browsers */
                url('${window.location.origin}/setting-service/static/printFont/IDAutomationC128S.ttf') format('truetype'), /* Safari, Android, iOS */
                url('${window.location.origin}/setting-service/static/printFont/IDAutomationC128S.svg#IDAutomationC128S') format('svg'); /* Legacy iOS */
              }
              .bug-free{background:url('${window.location.origin}/setting-service/printFont/IDAutomationSC39S.eot?#iefix')}
              @font-face {
                font-family: 'IDAutomationSC39S';
                src: url('${window.location.origin}/setting-service/static/printFont/IDAutomationSC39S.eot'); /* IE9 Compat Modes */
                src: url('${window.location.origin}/setting-service/static/printFont/IDAutomationSC39S.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
                url('${window.location.origin}/setting-service/static/printFont/IDAutomationSC39S.ttf') format('truetype');
              }
              .box, body{
                margin: 2pt 0 0 0;
                padding: 0;
                div {
                  margin: 0;
                  padding: 0;
                }
              }
            </style>
          </head>
          <body class="box">${this.htmlText()}</body></html>`);
    },
    htmlText (callback) {
      let str = '';
      let dom = this.deepCopy(this.$refs.container);
      let tagTemp = this.$refs.tagTemp;
      tagTemp.innerHTML = dom.parentNode.innerHTML;
      let container = tagTemp.childNodes[0];
      (this.pageData || []).forEach((n) => {
        for (let i = 0; i < n.num; i++) {
          container.childNodes[0].innerHTML = n[this.printViewParams[0]];
          if (this.printParams.productZhName) {
            container.childNodes[1].innerText = n[this.printViewParams[1]];
          }
          if (this.printParams.productNo) {
            container.childNodes[2].innerText = n[this.printViewParams[2]];
          }
          callback && callback();
          str += tagTemp.innerHTML;
        }
      });
      return str;
    },
    cancelPrintBarcode () { // 取消打印条码
      this.printModal = false;
      // this.printParams = this.deepCopy(this.printParamsCopy);
      // this.pageClass = this.deepCopy(this.pageClassCopy);
      // this.barCodeClass = this.deepCopy(this.barCodeClassCopy);
      this.$nextTick(() => {
        this.tagList = [];
        this.printNum = 1;
        this.tagContent = null;
        this.pageData = [];
        this.$emit('dataChange', []);
      });
    },
    delConfirm (idnex) {
      let v = this;
      v.tagList.splice(idnex, 1);
    }
  },
  created () {
    this.oldParams = this.$common.copy(this.printParams);
  },
  computed: {
    pagePrintData () {
      return this.deepCopy(this.printData || []).map(m => {
        return { ...m, number: m.num };
      });
    }
  }
};
</script>

<style lang="less" scoped>
.draggable {
  cursor: move;
}

.draggable.is-pointer-down {
  background: #09f;
  z-index: 2; /* above other draggies */
}

.draggable.is-dragging {
  opacity: 0.7;
}
</style>
